import React from "react";
import HandleCharacter from "../Handle/HandleCharacter";

function Character() {
    return <HandleCharacter />;
}

export default Character;
